/**
 * 工具类
*/
import CryptoJS from 'crypto-js'
var iv = CryptoJS.enc.Utf8.parse('0392039203920300') // 与后台统一
export default {
  // 加密
  encrypt(word) {
    var key = CryptoJS.enc.Utf8.parse('8251s14e032ad3mb') // 与后台统一
    var encrypted = CryptoJS.AES.encrypt(word, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC, // 根据上面得对应模式修改
      padding: CryptoJS.pad.Pkcs7 // 根据上面对应模式修改
    })
    return encrypted.toString()
  },
  // 解密
  decrypt(word, keyStr) {
    keyStr = keyStr || '8251s14e032ad3mb'
    // var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var key = CryptoJS.enc.Latin1.parse(keyStr)
    var decrypt = CryptoJS.AES.decrypt(word, key, { iv: iv, padding: CryptoJS.pad.ZeroPadding })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  }
}
